/**
 * @description This file contains the GraphQL mutation for publishing a network in the AppCMS. This is used in case of multi-brand/multi-network setups where each network can have its own configurations and branding.
 * */
import { gql } from '@apollo/client'

export const NETWORK_PUBLISH_MUTATION = gql`
  mutation NetworkPublish($site: String!, $network: String!) {
    networkPublish(site: $site, network: $network) {
      success
    }
  }
`
